import JsonView from '@uiw/react-json-view';
import type { FC } from 'react';

type JsonViewerProps = {
    data: unknown;
    className?: string;
};

export const JsonViewer: FC<JsonViewerProps> = ({ data, className }) => {
    return (
        <div className={className}>
            <JsonView
                value={data as object}
                collapsed={false}
                shouldExpandNodeInitially={(_, { level }) => level <= 2}
                displayDataTypes={false}
                displayObjectSize={false}
                enableClipboard={false}
                shortenTextAfterLength={60}
                style={{
                    backgroundColor: 'transparent',
                    fontSize: '0.875rem',
                    lineHeight: '1.5',
                }}
            />
        </div>
    );
};
